import Avatar from '../Avatar'
import withAbbreviationAvatar from './withAbbreviationAvatar'

const ClientAvatar = withAbbreviationAvatar(Avatar)

export default ClientAvatar
